export default __webpack_public_path__ + "static/media/maintenance.7c6a7a85.svg";